import React from 'react';
import { motion } from 'framer-motion';
import { Check, Crown, Usb, Plus } from 'lucide-react';
export function PackageList() {
  const features = ['Mirror Photo Booth de lujo — espejo oval con iluminación LED cinematográfica', 'Instalación y configuración profesional', 'Atendente dedicado durante todo el evento', 'Fotos impresas ilimitadas durante el evento', 'Entrega de álbum con las fotos de todos los invitados, como recuerdo de ese día especial', 'Diseño personalizado con el nombre y fecha de tu celebración', 'Fondo/backdrop elegante incluido', 'Galería digital para compartir en redes', 'Atención en español de principio a fin', 'Puntualidad y profesionalismo garantizado'];
  return <section className="py-20 md:py-28 bg-ink relative" data-id="element-433" data-mp="207dazjhkdxq9">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-434" data-mp="2givyixxiltr">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-charcoal to-ink rounded-3xl p-8 md:p-12 shadow-2xl border border-gold/30 relative overflow-hidden" data-id="element-435" data-mp="2dodgwyh7b2z">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-32 bg-gold/10 blur-[50px] pointer-events-none" data-id="element-436" data-mp="usfq04v7x2y1"></div>

          <div className="text-center mb-12 relative z-10" data-id="element-437" data-mp="zrivtrj0vd72">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-6" data-id="element-438" data-mp="m15ptupoy8kd">
              <Crown className="w-8 h-8 text-gold" data-id="element-439" data-mp="q0wiy52ox0s2" />
            </div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-4" data-id="element-440" data-mp="1dra7vmpzajif">
              El Paquete Completo
            </h2>
            <p className="text-lg text-cream/80 font-light max-w-2xl mx-auto" data-id="element-441" data-mp="1ik3c89hjbptz">
              Cuando nos contratas, no estás rentando un equipo. Estás
              contratando una experiencia completa:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 relative z-10" data-id="element-442" data-mp="1jdu6lx9jkwjm">
            {features.map((feature, index) => <div key={index} className={`flex items-start gap-3 p-3 rounded-lg hover:bg-white/5 transition-colors ${index === 0 ? 'md:col-span-2 bg-gold/5 border border-gold/20 p-4 rounded-xl' : ''}`} data-id="element-443" data-mp="1edobu87z6txb" data-mpi={index}>
                <Check className={`shrink-0 mt-1 ${index === 0 ? 'w-6 h-6 text-gold' : 'w-5 h-5 text-gold/80'}`} data-id="element-444" data-mp="14n3hiwzc4bk7" />
                <span className={`${index === 0 ? 'text-lg font-medium text-gold' : 'text-cream/90 font-light'}`} data-id="element-445" data-mp="vpb11phvmxv8">
                  {feature}
                </span>
              </div>)}
          </div>

          {/* Optional add-ons */}
          <div className="mt-10 pt-8 border-t border-gold/15 relative z-10" data-id="element-446" data-mp="bmwum1z2f7vn">
            <div className="flex items-center gap-2 mb-4" data-id="element-447" data-mp="gkye2o0el97n">
              <Plus className="w-4 h-4 text-gold/70" data-id="element-448" data-mp="gjdl32tqlybw" />
              <h3 className="text-xs font-semibold text-gold/80 uppercase tracking-[0.15em]" data-id="element-449" data-mp="lk1l2dzy1pi9">
                Servicios opcionales
              </h3>
            </div>

            <div className="flex items-start gap-4 p-4 md:p-5 rounded-xl bg-ink/40 border border-dashed border-gold/25 hover:border-gold/50 transition-colors" data-id="element-450" data-mp="qh1osi9bmg67">
              <div className="shrink-0 w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center" data-id="element-451" data-mp="3u0mlv7if9caa">
                <Usb className="w-5 h-5 text-gold" data-id="element-452" data-mp="2rz0irk6lp2q" />
              </div>
              <div className="flex-1" data-id="element-453" data-mp="7m37hatg5x3t">
                <p className="text-cream/90 font-light text-base md:text-lg" data-id="element-454" data-mp="36ajwiz5w6kfd">
                  Entrega de Pendrive con las imágenes del evento en formato
                  digital
                </p>
                <p className="text-xs md:text-sm text-gold/70 mt-1 italic" data-id="element-455" data-mp="1gteobmvu69l4">
                  * Incluye cargo adicional por este concepto
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}